import { ROLE } from "../components/common";
import { SourcesType } from "../services/content_v1";
import { AccessRequestStatus, AccountResType, Role } from "../services/users_v1";

export const AVAIL_VIDEO_FORMATS = ['.mp4', '.MP4', '.webm', '.WEBM', '.ogg', '.OGG'];

export const ORDER_STATUSES = {
    [AccessRequestStatus.OPEN]: 'Orders status open',
    [AccessRequestStatus.PENDING]: 'Orders status pending',
    [AccessRequestStatus.GRANTED]: 'Orders status granted',
    [AccessRequestStatus.REJECTED]: 'Orders status rejected',
    [AccessRequestStatus.CANCELED]: 'Orders status canceled',
    [AccessRequestStatus.REDIRECTED]: 'Redirected',
    [AccessRequestStatus.COPIED]: 'Copied',
    [AccessRequestStatus.CLOSED]: 'Closed',
    [AccessRequestStatus.FORWARDED]: 'Forwarded',
    [AccessRequestStatus.ACTIVE]: 'Active',
    [AccessRequestStatus.ARCHIVED]: 'Archived'
};

export const GUEST_ID = '7';

export const PARTNER_RTYPES = [AccountResType.PARTNER_TVSRC_MDLG, AccountResType.PARTNER_TVSRC]; // Медиалогистика и Партнер источник 

export const ACCOUNT_TYPES = {
    [AccountResType.SITE]: 'Site owner',
    [AccountResType.PROVIDER]: 'Provider',
    [AccountResType.CONSUMER]: 'Consumer',
    [AccountResType.PARTNER]: 'Partner',
    [AccountResType.PARTNER_MODERATOR]: 'Partner moderator',
    [AccountResType.PARTNER_TVSRC_MDLG]: 'Partner source Medialogistika',
    [AccountResType.PARTNER_TVSRC]: 'Partner source',
    [AccountResType.GUEST]: 'Guest',
};

export const ORG_TYPES: { [key: number]: string; } = {
    0: 'Organization',
    1: 'Individual Entrepreneur',
    2: 'Self-Employed',
    3: 'Individual',
};

export const EMPTY_ROLE: Role = {
    id: NaN,
    label: ROLE.UNKNOWN,
    name: ROLE.UNKNOWN
};

// SATELLITE = 1, MEDIALOGISTIKA = 3, OTHER = 4, ANY = 5
export const SOURCE_MAP = {
    [SourcesType.ANY]: 'tv:ANY_SOURCE',
    [SourcesType.LAND]: 'tv:LAND',
    [SourcesType.MEDIALOGISTIKA]: 'tv:LAND',
    [SourcesType.SATELLITE]: 'tv:SATELLITE',
    [SourcesType.OTHER]: 'tv:OTHER_SOURCE',
};

export const MEDIABAZA_LANGS = [
    { value: 'ru', label: 'Русский' },
    { value: 'en', label: 'English' },
];

export const WELCOME_ROUTES = [
    '/join',
    '/login',
    '/about',
    '/adverts',
    '/polls',
    '/news',
    '/promo',
    '/public-adverts',
    '/public-polls',
    '/public-news',
    '/public-promo',
    '/public-showcase',
];

export const PUBLIC_ROUTES = [
    '/legal',
    '/contacts',
    '/help',
    '/sdn-public'
];
